<template>
  <div>
    <div class="title">{{ t('route.mfa') }}</div>
    <div class="content">
      <!-- 注意事项 -->
      <div class="tip">{{ t('noticeSetting.mfa_tip') }}</div>
      <div class="form-area">
        <custom-form
          ref="refForm"
          :loading="loading"
          :formData="formData"
          :formRules="formRules"
          @tipsClick="tipsClick"
          @submitForm="submitForm" />
        <div class="save_mfa">
          <el-button type="primary" :disabled="loading" :loading="submitLoading" @click="submit">{{ t('form.submit') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { reactive, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import checkRules from '@/components/CustomCheck'
import { updateSysConfig, getSysConfigs, getSysConfig } from '@/api/noticeSetting'
import { ElMessage } from 'element-plus'
const { t } = useI18n()
const refForm = ref()
const submitLoading = ref(false)
const loading = ref(true)
// 规则校验
const { emptCheck } = checkRules(t)
const formRules = reactive({
  status: emptCheck,
  sys_email_id: emptCheck,
  type: emptCheck
})
const formData = reactive({
  status: { // 启用状态
    type: 'switch',
    label: t('alarm.status'),
    hiddenText: true,
    activeValue: 'enabled',
    prop: 'status',
    inactiveValue: 'disabled',
    value: 'enabled'
  },
  type: { // 启用类型
    type: 'redio',
    label: t('noticeSetting.mfa_type'),
    prop: 'type',
    value: 'mfa_email',
    options: [
      {
        query_name: 'mfa_email',
        display_name: t('noticeSetting.mfa_email')
      }
    ]
  },
  sys_email_id: { // 发送通道
    type: 'select',
    label: t('noticeSetting.mfa_channel'),
    prop: 'sys_email_id',
    value: null,
    options: [],
    tip: `${t('noticeSetting.mfa_channel_tip')}<span class="click_here">${t('noticeSetting.click_here')}</span>`
  }
})
// 获取通道列表
const getChannelList = async () => {
  formData.sys_email_id.loading = true
  try {
    const res = await getSysConfigs({ name: 'sys_email', page: 1, page_size: 99999 })
    formData.sys_email_id.options = res.data.pages
    formData.sys_email_id.loading = false
    getSysConfigData()
  } catch (error) {
    formData.sys_email_id.loading = false
  }
}
// 获取上次配置
const getSysConfigData = async () => {
  loading.value = true
  try {
    const res = await getSysConfig({ name: 'mfa_email', display_name: 'mfa_email' })
    formData.status.value = res.data.status
    // 查询上次配置的发送通道是否存在，不存在则设置为空
    const obj = formData.sys_email_id.options.find(item => item.id === res.data.metadata.sys_email_id)
    formData.sys_email_id.value = obj ? res.data.metadata.sys_email_id : null
    loading.value = false
  } catch (error) {
    loading.value = false
  }
}
// 确定
const submit = () => {
  refForm.value.submit()
}
// 表单提交
const submitForm = (form) => {
  form.validate(async valid => {
    if (!valid) return
    const formVal = {
      name: 'mfa_email',
      display_name: 'mfa_email',
      update_data: {
        status: formData.status.value,
        metadata: {
          sys_email_id: formData.sys_email_id.value
        }
      }
    }
    submitLoading.value = true
    try {
      const res = await updateSysConfig(formVal)
      if (res.code === '00000000') {
        ElMessage.success(`${t('table.success')}`)
      }
      submitLoading.value = false
    } catch (error) {
      submitLoading.value = false
    }
  })
}
onMounted(() => {
  getChannelList()
})
// 提示信息点击
const tipsClick = (item) => {
  if (item.prop === 'sys_email_id') {
    window.open(`${window.location.origin}/noticeSetting/email`, '_blank')
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.title {
  margin-bottom: 16px;
  font-size: 14px;
  color: $grey-9;
}

.tip {
  border: 1px solid var(--el-color-warning);
  padding: 8px 16px;
  color: $grey-8;
  font-size: 14px;
  border-radius: 2px;
  line-height: 22px;
  background-color: #FFFAF0;
  margin-bottom: 16px;
}
.form-area {
  width: 620px;
  margin: 0 auto;
  .save_mfa {
    margin-top: 16px;
    width: 100%;
    text-align: right;
  }
  :deep(.el-form-item__error) {
    margin-top: 20px !important;
  }
}
</style>